export const SUPPORT_BASE_URL = 'https://support.maap.cc/hc/en-us/';

export const SUPPORT_PATHS = {
    'Shipping & Delivery': `${SUPPORT_BASE_URL}categories/4408473873677-Shipping-Delivery`,
    Returns: `${SUPPORT_BASE_URL}categories/360002401971-Returns-Exchanges`,
    'Crash Replacement': `${SUPPORT_BASE_URL}categories/360002392332-Crash-Replacement`,
};
